export default __webpack_public_path__ + "static/media/c2.ba20854e.png";